import { render, staticRenderFns } from "./OrderListAll.vue?vue&type=template&id=537648d4"
import script from "./OrderListAll.vue?vue&type=script&lang=js"
export * from "./OrderListAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports